import React from 'react';
import SuccessModal from '../common/SuccessModal';
import IconReset from '../../assets/icons/ic-reset.svg';

interface PasswordResetModalProps {
  open: boolean;
  onClose: () => void;
}

const PasswordResetModal: React.FC<PasswordResetModalProps> = ({ open, onClose }) => {
  return (
    <SuccessModal
      open={open}
      onClose={onClose}
      icon={IconReset}
      title="Password reset successful"
      description={
        <>
          Your password has been successfully reset. You can now sign in with your new credentials.
        </>
      }
    />
  );
};

export default PasswordResetModal;

